import React from 'react'

export const submitCall = (submitValues, errorField, submitPath, setFieldError, pathWithParams) => {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(submitValues)
    };
    fetch(submitPath, requestOptions)
        .then(async response => {
            const data = await response.json()

            if (!response.ok) {
                const nameError = (data && data.company)
                const emailError = (data && data.email)
                if (nameError) {
                    setFieldError(errorField, <span>{nameError} Please try another name or <a href='mailto:contact@hubbleiq.com'>Contact us!</a> for help</span>)
                }
                if (emailError) {
                    setFieldError('email', <span>{emailError} or <a href='mailto:contact@hubbleiq.com'>Contact us!</a> for assistance.</span>)
                }

                return Promise.reject(nameError)
            } else if (response.ok) {
                if (pathWithParams) {
                    window.location = pathWithParams()
                }
            }
        })
        .catch(error => {
            console.log('ERROR!', error)
        })
}

export const nextButtonCheck = (localAttributeValue, proAttributeValue, attributeCheckSize) => {
    return (localAttributeValue && localAttributeValue.length > attributeCheckSize) || (proAttributeValue && proAttributeValue.length > attributeCheckSize)
}
